module.exports = __webpack_public_path__ + "img/MICROSAT.2e986a45.png";